/* Shows each colour's status on the dots of shop cards and product pages (window.KATHA_SW, from snippets/kh-swatch-flags).
   Status is per fabric (Content > Metaobjects > Studio colour). The fabric of a dot comes from its card/page: data-tex, or the
   fabric word in the card. If the fabric can't be told, nothing is shown unless every fabric has the same status.
   The bundle builder draws its own status, so it is left alone. */
(function () {
  var D = window.KATHA_SW; if (!D) return;
  var hasMo = D.mo && Object.keys(D.mo).length, hasPh = D.photo && Object.keys(D.photo).length; if (!hasMo && !hasPh) return;
  var SEL = '.kh-dot,.kp-colour';
  var TEX = { linen: 'linen', eucalyptus: 'eucalyptus', cotton: 'organic cotton', waffle: 'waffle' };
  var FABS = ['linen', 'eucalyptus', 'organic cotton', 'waffle'];
  var busyTxt = D.busy ? 'ships in ' + D.busy + (D.busyMax && D.busyMax !== D.busy ? '–' + D.busyMax : '') + ' working days' : 'takes a little longer';
  // The first 600 characters of a box's text, without building the text of the whole box (main is ~100 KB of HTML)
  function headText(c) {
    var t = '', wk = document.createTreeWalker(c, NodeFilter.SHOW_TEXT), n;
    while (t.length < 600 && (n = wk.nextNode())) t += n.nodeValue;
    return t.slice(0, 600);
  }
  function fabricOf(el) {
    var t = el.closest('[data-tex]'); if (t && TEX[t.getAttribute('data-tex')]) return TEX[t.getAttribute('data-tex')];
    var c = el.closest('.kh-card,[data-kp-fabric],main,body'); var txt = (c ? (c.getAttribute('data-fabric') || headText(c)) : '').toLowerCase();
    if (/linen waffle|waffle linen/.test(txt)) return 'waffle'; if (/eucalyptus/.test(txt)) return 'eucalyptus'; if (/organic cotton|egyptian cotton|\bcotton\b/.test(txt)) return 'organic cotton'; if (/linen/.test(txt)) return 'linen';
    return '';
  }
  function colour(el) { return String(el.getAttribute('data-colour') || el.getAttribute('title') || el.getAttribute('aria-label') || '').split(/[,·]/)[0].trim().toLowerCase(); }
  function statusFor(f, c) {
    if (f) return D.mo[f + '|' + c] || '';
    var seen = FABS.map(function (x) { return D.mo[x + '|' + c]; }).filter(Boolean); return seen.length === 1 && FABS.every(function (x) { return !D.mo[x + '|' + c] || D.mo[x + '|' + c] === seen[0]; }) && FABS.filter(function (x) { return D.mo[x + '|' + c]; }).length > 1 ? seen[0] : '';
  }
  function apply(el) {
    if (el.__ksw) return; var c = colour(el); if (!c) return; el.__ksw = 1;
    var s = hasMo ? statusFor(fabricOf(el), c) : '', add = '';
    if (s === 'Low stock') { el.setAttribute('data-kst', 'low'); add = 'low stock'; }
    else if (s === 'Pre-order') { el.setAttribute('data-kst', 'pre'); add = 'pre-order'; }
    else if (s === 'Busy') { el.setAttribute('data-kbusy', '1'); add = busyTxt; }
    else if (s === 'Sold out' || s === 'Back soon') { el.setAttribute('data-kst', 'out'); add = s.toLowerCase(); }
    var t = el.getAttribute('title'); if (add && t) el.setAttribute('title', t + ', ' + add);
    var ph = hasPh && D.photo[c]; if (ph) { var tgt = el.querySelector('span,i') || el; tgt.style.background = 'url(' + ph + ') center/cover'; }
  }
  // The bundle builder draws its own status, but its dots should still show a photo set for the colour
  function photoOnly(el) {
    if (el.__kph) return; var c = colour(el); if (!c) return; el.__kph = 1;
    var ph = D.photo && D.photo[c]; if (ph) { var tgt = el.querySelector('i,span') || el; tgt.style.background = 'url(' + ph + ') center/cover'; }
  }
  function run() { document.querySelectorAll(SEL).forEach(apply); if (hasPh) document.querySelectorAll('.kbb-sw,.kbs-sw').forEach(photoOnly); }
  // New dots (cards loaded later, the bag) are picked up once per burst of changes, not on every single change
  var later = 0;
  run(); document.addEventListener('DOMContentLoaded', run);
  new MutationObserver(function () { if (!later) later = setTimeout(function () { later = 0; run(); }, 60); }).observe(document.documentElement, { childList: true, subtree: true });
})();
